<template>  
  <div class="purchaseorderdetailPage">
    <XR-head titleText="订单详情"></XR-head>
    <div class="order-state" v-if="!loaded" :style="{  backgroundImage:'url('+siteConfig.MobileBgImage+')' }">
      <p class="state-text">{{purchaseorderdetailPage.StateName}}</p>
    </div>
    <router-link :to="'/salesman/purchaseorderdelivery?orderNo='+purchaseorderdetailPage.OrderNo" class="" v-if="purchaseorderdetailPage.DeliveryType == 1 && purchaseorderdetailPage.DeliveryTracking && purchaseorderdetailPage.DeliveryTracking[0].WuLiu">
      <div class="delivery" v-if="!loaded">
        <div class="leftIcon">
          <i class="fa fa-delivery"></i>
        </div>
        <div class="delivery-process">
          <div class="text">{{ purchaseorderdetailPage.DeliveryTracking[0].WuLiu.data.length>0?purchaseorderdetailPage.DeliveryTracking[0].WuLiu.data[0].context : purchaseorderdetailPage.DeliveryTracking[0].WuLiu.message}}</div>
        </div>
        <div class="rightIcon">
          <i class="fa fa-angle-right"></i>
        </div>
      </div>
    </router-link>
    <div class="order-delivery" v-if="!loaded && purchaseorderdetailPage.DeliveryType == 1">
      <div class="mapIcon">
            <img src="/static/icon/address-location.png" />
          </div>
      <div class="delivery-info">
        <div class="member-info">
          <p class="username">{{purchaseorderdetailPage.OrderDelivery.Receiver}}</p>
          <p class="mobile">{{purchaseorderdetailPage.OrderDelivery.Phone}}</p>
        </div>
        <div class="address">{{purchaseorderdetailPage.OrderDelivery.Address}}</div>
      </div>
    </div>

    <div class="order-list" v-if="!loaded">
      <div class="order-item">
        <div class="shopRow">          
            <!-- <div class="all-chk"><mu-checkbox class="cart-all-chk" :nativeValue="cartItem.ShopId" @change="shopClick(cartItem.ShopId)" uncheckIcon=":fa fa-circle-thin" checkedIcon=":fa fa-yes"/></div> -->
            <div class="shopName">
              <img :src="purchaseorderdetailPage.ShopLogo" class="shopLogo" />
              <div class="shopNameValue">
                <span>{{purchaseorderdetailPage.ShopName}}</span>
                <i class="fa fa-angle-right"></i>
              </div>
            </div>      
          </div>  
        <!-- <div class="shoptip">
          <img class="shop-logo" :src="purchaseorderdetailPage.ShopLogo" />
          <p class="shop-name">{{purchaseorderdetailPage.ShopName}}</p>
          <p class="state"></p>
        </div> -->
        <div class="hidden-scorll">
          <div class="suborder-item-list">
            <div class="suborder-item" v-for="orderItem in purchaseorderdetailPage.OrderItems" :key="orderItem.ItemId">              
              <router-link :to="'/wholesale/productDetail?skuId='+orderItem.SkuId">
                <img :src="orderItem.DetailImage?orderItem.DetailImage:IMGServer_URL+'/images/index-item-default.png'" onerror="this.src=IMGServer_URL+'/images/index-item-default.png'" class="order-img" />
              </router-link> 
              <div class="product-info" :style="{ width:suborderItemProductNameWidth+'px'}">                      
                <router-link :to="'/wholesale/productDetail?skuId='+orderItem.SkuId">
                  <p class="product-name">{{orderItem.ProductName}}</p>
                </router-link>
                <p class="attr">数量:{{orderItem.Quantity}} {{orderItem.Attribute}}</p>
                <p class="state">{{orderItem.StateName}}</p>
                <p class="price"><i class="fa fa-rmb"></i>{{orderItem.SalePrice.toFixed(2)}}</p>
                <router-link class="item-button" :to="'/salesman/purchaseOrderEvaluate?itemId='+orderItem.ItemId+'&skuId='+orderItem.SkuId" v-if="orderItem.State==2 && !orderItem.IsComment">评价</router-link>
                <button class="item-button receive" @click="orderItemConfrim(orderItem.ItemId)" v-if="purchaseorderdetailPage.DeliveryType==1 && orderItem.State==1">确认收货</button>
              </div>  
            </div>
          </div>
          <div class="order-detail" v-if="!loaded">
      <div class="order-info">
        <div class="field"><span>订单编号：</span>{{purchaseorderdetailPage.OrderNo}}</div>
        <div class="field"><span>下单时间：</span>{{purchaseorderdetailPage.Time.CreateDateName}}</div>
        <div class="field payOverDate" v-if="purchaseorderdetailPage.State ==1"><span>超时时间：</span><span class="payOverDateTime">{{payOverDateName}}</span></div>
        <div class="field" v-if="purchaseorderdetailPage.DeliveryType != 1 && purchaseorderdetailPage.OrderDelivery.PickUpPassword">
          <span>自提码：</span>
          <span v-show="show">{{purchaseorderdetailPage.OrderDelivery.PickUpPassword}}</span>
          <span v-show='!show' @click="show = !show" style="color:#000;padding: 0 10px;">查看自提码</span>
        </div>

      </div>
      <div style="width:90%;height:1px;margin: 0px 10px;border-top:1px dashed #eee"></div>
      <div class="order-info">
        <div class="field"><span>支付方式：</span>{{purchaseorderdetailPage.OrderPay.PayTypeName}}</div>
        <div class="field"><span>支付时间：</span>{{purchaseorderdetailPage.Time.PayDateName}}</div>
      </div>
      <div style="width:90%;height:1px;margin: 0px 10px;border-top:1px dashed #eee"></div>
      <div class="order-info">
        <div class="field"><span>配送方式：</span>{{purchaseorderdetailPage.OrderDelivery.ShippingMethodName}}</div>
        <div class="field"><span>期望配送日期：</span>{{ purchaseorderdetailPage.DeliveryType == 1 ? purchaseorderdetailPage.OrderDelivery.ShippingDateName:purchaseorderdetailPage.OrderDelivery.SelfPickUpDate}}</div>
        <template v-if="purchaseorderdetailPage.OrderDelivery.ShippingMethodId == 3">
          <div class="field"><span>自提点：</span> {{purchaseorderdetailPage.OrderDelivery.CompanyName}}</div>
          <div class="field"><span>联系电话：</span> {{purchaseorderdetailPage.OrderDelivery.ContactPhone}}</div>
        </template>
      </div>
      <div style="width:90%;height:1px;margin: 0px 10px;border-top:1px dashed #eee"></div>
      <div class="order-info">
        <div class="field" style="margin:5px 0;"><span>发票抬头：</span>{{purchaseorderdetailPage.InvoiceHead}}</div>
      </div>
      <div style="width:90%;height:1px;margin: 0px 10px;border-top:1px dashed #eee"></div>
      <div class="order-info">
        <div class="field"><span>留言：</span>{{purchaseorderdetailPage.Remark}}</div>
      </div>
    </div>
        </div>
      </div>
    </div>
    
    
    <div class="order-detail" v-if="!loaded">  
      <div class="order-info">
        <div class="field">
          <span class="title">商品总额</span>
          <span class="num"><i class="fa fa-rmb"></i>{{purchaseorderdetailPage.OrderMoney.ProductMoney.toFixed(2)}}</span>
        </div>
        <div class="field">
          <span class="title">运费</span>
          <span class="num"><i class="fa fa-rmb"></i>{{purchaseorderdetailPage.OrderMoney.FreightMoney.toFixed(2)}}</span>
        </div>
        <div class="field" v-if="purchaseorderdetailPage.OrderMoney.TotalMoney-purchaseorderdetailPage.OrderMoney.CashMoney>0">
          <span class="title">配货抵扣</span>
          <span class="num">-<i class="fa fa-rmb"></i>{{(purchaseorderdetailPage.OrderMoney.TotalMoney-purchaseorderdetailPage.OrderMoney.CashMoney).toFixed(2)}}</span>
        </div>
        <div class="summary">
          <span class="title">实付款:</span>
          <span class="num"><i class="fa fa-rmb"></i>{{purchaseorderdetailPage.OrderMoney.CashMoney.toFixed(2)}}</span>
        </div>
      </div>
    </div>
    <div class="operator" v-if="!loaded && (purchaseorderdetailPage.State == 1 || purchaseorderdetailPage.State == 3 || (purchaseorderdetailPage.DeliveryType==1 && purchaseorderdetailPage.IsReceiver && (purchaseorderdetailPage.State==5 || purchaseorderdetailPage.State==6)))">
      <div class="button-list">
        <router-link :to="'/wholesale/orderPay?orderNo='+purchaseorderdetailPage.OrderNo" style="background-color:red;float:right;" v-if="purchaseorderdetailPage.State == 1">
          <mu-raised-button label="付款" class="button-item gobuy" primary></mu-raised-button>
        </router-link>
        <mu-raised-button label="取消订单" @click="orderCancel(purchaseorderdetailPage.OrderNo)" class="orderBtn button-item receive" v-if="purchaseorderdetailPage.State ==1" style="background-color:#7C838B;color:#F2F2F3;float:right;"></mu-raised-button>  
        
        <!-- <mu-raised-button label="再次购买" primary></mu-raised-button> -->
        <mu-raised-button label="确认收货" class="button-item" @click="orderConfrim" primary v-if="purchaseorderdetailPage.DeliveryType==1 && purchaseorderdetailPage.IsReceiver && (purchaseorderdetailPage.State==5 || purchaseorderdetailPage.State==6)"></mu-raised-button>
        <mu-raised-button label="修改地址" style="width:50%;background-color:red;" class="button-item" :to="'/salesman/purchaseordermodifyaddress?orderNo='+purchaseorderdetailPage.OrderNo" primary v-if="purchaseorderdetailPage.DeliveryType==1 && (purchaseorderdetailPage.State==3)"></mu-raised-button>
      </div>
    </div>    
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
export default {
  data () {
    return {
      show:false,
      fullWidth:document.documentElement.clientWidth,
      suborderItemProductNameWidth: (parseInt(document.documentElement.clientWidth)-105),
      loaded:true,
      purchaseorderdetailPage:{},
      payOverDateName:'',
      siteConfig:{ MobileBgImage : '' }
    }
  },
  mounted(){
    this.$refs.XRtoast.load()
    this.getSiteInfo()
    this.getOrderDetail()
  },
  methods: {
    getSiteInfo: function () {    
        const ths = this;
        this.$post('/Shop/SiteConfigServer/GetSiteConfig')
            .then(function (res) {
            if(res.IsSuccess){
                ths.siteConfig = res.Data
            }         
        })
        .catch(function (err) {
            console.log(err)
        })    
    },      
    getOrderDetail(){    
     
      var ths = this;   
      ths.$post(
        "/Shop/PurchaseServer/GetOrderDetail",
        JSON.stringify({orderno: this.$route.query.orderNo})
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.loaded =false
          ths.purchaseorderdetailPage = res.Data
          ths.$refs.XRtoast.hide()
          if(res.Data.State == 1){
            var overDate = res.Data.Time.PayOverDate.replace('T',' ')
            overDate = overDate.replace(new RegExp('-','g'),"/")
            var nowDate = res.Data.Time.NowTimeName
            nowDate = nowDate.replace(new RegExp('-','g'),"/")
            var ts = (new Date()) - (new Date(nowDate))
            ths.calcPayOverDate(overDate, ts)
          }
        }
      });
    },
    calcPayOverDate(payOverDate, tmpTs){      
      var ths = this
      var interval = setInterval(function(){
        var ts = (new Date(payOverDate)) - (new Date()) - tmpTs ; //计算剩余的毫秒数    
        if (ts <= 0) {
            ths.payOverDateName='已超时'
            clearInterval(interval);
            return;
        }
        var hh = parseInt(ts / 1000 / 60 / 60, 10); //计算剩余的小时数  
        var mm = parseInt(ts / 1000 / 60 % 60, 10); //计算剩余的分钟数  
        var ss = parseInt(ts / 1000 % 60, 10); //计算剩余的秒数 

        if(hh<10){
          hh= '0'+hh
        }
        if(mm<10){
          mm= '0'+mm
        }
        if(ss<10){
          ss= '0'+ss
        }

        ths.payOverDateName = hh+'时'+mm+"分"+ss+'秒' 
      },1000)
    },
    orderConfrim(){      
      var ths = this;   
      ths.$post(
        "/Shop/PurchaseServer/OrderConfrim",
        JSON.stringify({OrderNos: [this.purchaseorderdetailPage.OrderNo]})
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.$refs.XRtoast.success(res.Msg, true)
          ths.getOrderDetail()
        }
      });
    },
    orderItemConfrim(itemId){
      
      var ths = this;   
      ths.$post(
        "/Shop/PurchaseServer/OrderItemConfrim",
        JSON.stringify({orderItemNos: [itemId]})
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.$refs.XRtoast.success(res.Msg, true)
          ths.getOrderDetail()
          
        }
      });
    },
    orderCancel(orderNo){      
      var ths = this;   
      ths.$post(
        "/Shop/PurchaseServer/orderCancel",
        JSON.stringify({OrderNo: orderNo})
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.$refs.XRtoast.successCallback(res.Msg, function(){
            ths.getOrderDetail()
          })
        }
      });
    },
  }
}
</script>

<style>
#app .purchaseorderdetailPage{
  background: #eee;
  bottom:unset;
  padding-bottom: 56px;
}
.purchaseorderdetailPage .order-state{
  overflow: hidden;
  line-height: 60px;
  background: url(/static/us-top-bg.png);
  background-size: 100% 100%;
  color:white;
  padding-left: 15px;

}
.purchaseorderdetailPage .order-item .shopRow{
  background: white;
  overflow: hidden;
  color:#666;
  border-radius: 10px;
  width: 100%;
  padding: 15px 10px;
}
.purchaseorderdetailPage .order-item .shopRow .all-chk{
  float: left;
  width: 40px;
  margin-top: 6px;
  text-align: center;
}
.purchaseorderdetailPage .order-item .shopRow .shopName{
  padding-left: 10px;
  vertical-align: middle;
}
.purchaseorderdetailPage .order-item .shopRow .shopName .shopLogo{
  float: left;
  width:20px;
  height: 20px;
  border-radius: 50%;
}
.purchaseorderdetailPage .order-item .shopRow .shopName .shopNameValue{
  float: left;
  height: 20px;
  line-height: 20px;
  margin-left: 5px;
  font-size: 14px;
}
.purchaseorderdetailPage .delivery {
  overflow: hidden;
  background: white;
  padding:15px 10px;
  margin-top: 10px;
}
.purchaseorderdetailPage .delivery .fa{  
  width: 30px;
  margin-top: 4px;
}
.purchaseorderdetailPage .delivery .leftIcon {
  float:left;
}
.purchaseorderdetailPage .delivery .rightIcon {
  float:right;
  text-align: center;
  margin-top: -23px;
}
.purchaseorderdetailPage .delivery .delivery-process{
  overflow: hidden;
  padding-right: 40px;
}
.purchaseorderdetailPage .delivery-process .text{
  font-size: 12px;
  color:#999;
  line-height: 16px;
  height: 32px;
  word-break: break-all;
  overflow:hidden;
  text-overflow:ellipsis;
}

.purchaseorderdetailPage .order-delivery {
  overflow: hidden;
  background: white;
  padding:10px;
  margin-top: 10px;
}
.purchaseorderdetailPage .order-delivery .fa {
  float:left;
  width: 30px;
  margin-top: 4px;
}
.purchaseorderdetailPage .order-delivery .delivery-info{
  overflow: hidden;
}
.purchaseorderdetailPage .order-delivery .delivery-info .member-info{
  overflow: hidden;
}
.purchaseorderdetailPage .hidden-scorll{background-color: #FCFCFC;}
.purchaseorderdetailPage .order-delivery .member-info .username{
  float: left;
}
.purchaseorderdetailPage .order-delivery .member-info .mobile{
  float: left;
  margin-left: 14px;
}
.purchaseorderdetailPage .order-delivery .address{
  font-size: 12px;
  color:#999;
}
.purchaseorderdetailPage .mapIcon{
  float: left;
  width: 30px;
  line-height: 40px;
}
.purchaseorderdetailPage .mapIcon img{
  width:100%;
  display: block;
  margin-top: 10px;
}
.purchaseorderdetailPage .order-list{
  border-radius: 10px;
  overflow: hidden;
}
.purchaseorderdetailPage .order-item{
  border-radius: 10px;
  background: white;
  margin: 10px 0 0;
}
.purchaseorderdetailPage .shoptip{
  background: white;
  overflow: hidden;
  color:#666;
  width: 100%;
  padding: 15px 10px;
  /* overflow: hidden;
  background: white;
  padding:0 10px;
  border-bottom:1px solid #eee; */
}
.purchaseorderdetailPage .shoptip .shop-logo{
  float: left;
  width:20px;
  height: 20px;
  border-radius: 50%;
}
.purchaseorderdetailPage .shoptip .shop-name{
  float: left;
  line-height: 48px;
}
.purchaseorderdetailPage .shoptip .state{
  float: right;
  line-height: 48px;
}

.purchaseorderdetailPage .suborder-item-list{
  overflow: hidden;
  padding-left: 10px;
}
.purchaseorderdetailPage .suborder-item{
  width:100%;
  overflow: hidden;
  padding: 20px 0;
}
.purchaseorderdetailPage .suborder-item .order-img{
  width: 75px;
  height:75px;
  float: left;
  border: 1px solid #eee;
  padding: 1px;
  background: white;
}
.purchaseorderdetailPage .suborder-item .product-info{
  float: left;
  padding: 1px;
  margin-left: 10px;
  margin-right: 10px;
  word-break: break-all;
  height: 95px;
}
.purchaseorderdetailPage .suborder-item .product-info .product-name{
  word-break: break-all;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  line-height: 16px;
  font-size: 14px;
  padding-bottom: 10px;
  color:#333;
}
.purchaseorderdetailPage .suborder-item .product-info .attr{
  word-break: break-all;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  line-height: 14px;
  font-size: 12px;
  color:#999;
}
.purchaseorderdetailPage .suborder-item .product-info .state{
  word-break: break-all;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  line-height: 16px;
  font-size: 12px;
  margin-top: 14px;
  color:red;
}
.purchaseorderdetailPage .suborder-item .product-info .price{
  word-break: break-all;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  line-height: 16px;
  font-size: 12px;
  margin-top: 10px;
  float: left;
}
.purchaseorderdetailPage .suborder-item .product-info .item-button{
  float: right;
  height: 26px;
  line-height: 26px;
  font-size: 12px;
  margin-top: 6px;
  width: 60px;
  margin: 8px 0 0 0;
  padding:0;
  border: none;
  background: #f9f9f9;
  color:#999;
  border:1px solid #999;
  border-radius: 2px;
  margin-left: 10px;
  text-align: center;
}

.purchaseorderdetailPage .order-total{
  overflow: hidden;
}
.purchaseorderdetailPage .total-text{
  float: right;  
  font-size: 12px;
  line-height: 48px;
}
.purchaseorderdetailPage .total-text span{
  font-size: 14px;
}

.purchaseorderdetailPage .order-detail{
  margin: 10px 0;
  background: white;
  border-radius: 10px;
}
.purchaseorderdetailPage .order-info {
  padding: 10px 0;
}
.purchaseorderdetailPage .order-info .field{
  line-height: 24px;
  font-size: 12px;
  padding-left: 10px;
  padding-right: 10px;
  color:#999;
  overflow: hidden;
}
.purchaseorderdetailPage .order-info .field span{
  color: #4D4A49;
}
.purchaseorderdetailPage .order-info .field .title{
  float: left;
}
.purchaseorderdetailPage .order-info .field .num{
  float: right;
  font-size: 14px;
}
.purchaseorderdetailPage .order-info .field .payOverDateTime{
  color:red;
}
.purchaseorderdetailPage .order-info .fa{
  font-size: 12px;
}
.purchaseorderdetailPage .order-info .summary{
  line-height: 16px;
  font-size: 16px;
  text-align: right;
  margin: 10px 0 0 10px;
  padding: 15px 10px 5px;
}
.purchaseorderdetailPage .order-info .summary .num{
  color:red;
}


.purchaseorderdetailPage .order-operator{
  overflow: hidden;
}
.purchaseorderdetailPage .order-operator .button-list{
  float: right;
  padding: 10px 10px;
}

.purchaseorderdetailPage .operator{  
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  background: #f9f9f9;
}
.purchaseorderdetailPage .operator .button-list{
  float: right;
}
.purchaseorderdetailPage .operator .button-list .button-item{
  height: 56px;
  background-color: rgb(244, 67, 54);
}
</style>



// WEBPACK FOOTER //
// src/pages/salesman/purchaseorderdetail.vue